import React from 'react';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helpText?: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, helpText, className = '', id, ...props }, ref) => {
    const inputId = id || `textarea-${Math.random().toString(36).substr(2, 9)}`;
    const errorClass = error ? 'error' : '';

    return (
      <div className="form-group">
        {label && (
          <label htmlFor={inputId} className="form-label">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={inputId}
          className={`form-textarea ${errorClass} ${className}`}
          {...props}
        />
        {error && <span className="form-error">{error}</span>}
        {helpText && !error && <span className="form-help">{helpText}</span>}
      </div>
    );
  },
);

Textarea.displayName = 'Textarea';

export default Textarea;
